<!-- <p>profile-order-listing works!</p> -->
<h3 class="text-2xl text-left mb-5 mt-1 font-semibold">Your Orders</h3>
<div *ngIf="orderListBpm.length>=1"
	 class="grid grid-cols-2 lg:grid-cols-4 gap-2 my-2 mb-7">
	<div (click)="filterOrder('ALL')"
		 [ngClass]="selectedTab === 'ALL'? 'fb-order-selected-tab':''"
		 class="bg-white cursor-pointer rounded-md border-[1px] border-gray-100 flex justify-start gap-2 md:gap-3 px-4 py-2">
		<div class="rounded-full bg-[#EDF2FE] p-3 flex justify-center items-center">
			<span class="text-[#5950B7] material-symbols-outlined">package_2</span>
		</div>
		<div class="flex flex-col gap-1">
			<p class="font-bold">{{orderListBpm.length}}</p>
			<p class="text-gray-500 text-xs">Total Order</p>
		</div>
	</div>

	<div (click)="filterOrder('PROCESSING')"
		 [ngClass]="selectedTab === 'PROCESSING'? 'fb-order-selected-tab':''"
		 class="bg-white cursor-pointer rounded-md border-[1px] border-gray-100 flex justify-start gap-2 md:gap-3 px-4 py-2">
		<div class="rounded-full bg-[#FFFBE8] p-3 flex justify-center items-center">
			<span class="text-[#BB955E] material-symbols-outlined">package_2</span>
		</div>
		<div class="flex flex-col gap-1">
			<p class="font-bold">{{activeOrders.length}}</p>
			<p class="text-gray-500 text-xs">Active Order</p>
		</div>
	</div>

	<div (click)="filterOrder('DISPATCHED')"
		 [ngClass]="selectedTab === 'DISPATCHED'? 'fb-order-selected-tab':''"
		 class="bg-white cursor-pointer rounded-md border-[1px] border-gray-100 flex justify-start gap-2 md:gap-3 px-4 py-2">
		<div class="rounded-full bg-[#ECFDF5] p-3 flex justify-center items-center">
			<span class="text-[#52a183] material-symbols-outlined">package_2</span>
		</div>
		<div class="flex flex-col gap-1">
			<p class="font-bold">{{completedOrders.length}}</p>
			<p class="text-gray-500 text-xs">Dispatched Order</p>
		</div>
	</div>

	<div (click)="filterOrder('CANCELLED')"
		 [ngClass]="selectedTab === 'CANCELLED'? 'fb-order-selected-tab':''"
		 class="bg-white cursor-pointer rounded-md border-[1px] border-gray-100 flex justify-start gap-2 md:gap-3 px-4 py-2">
		<div class="rounded-full bg-[#FEF6F6] p-3 flex justify-center items-center">
			<span class="text-[#AE3E39] material-symbols-outlined">package_2</span>
		</div>
		<div class="flex flex-col gap-1">
			<p class="font-bold">{{cancelledOrders.length}}</p>
			<p class="text-gray-500 text-xs">Cancelled Order</p>
		</div>
	</div>
</div>
<div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-x-8 lg:gap-y-5">
	<ng-container *ngFor="let item of filteredOrderList">
		<fb-order-list-card [item]="item" class="fb-order-card"></fb-order-list-card>
	</ng-container>
</div>
<ng-container *ngIf="filteredOrderList.length<1">
	<div class="order_not_found rounded-lg">
		No order item has been found.
	</div>
</ng-container>
